<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Terméktörténet</span>
    </div>
    <div v-loading="loading" class="filter-container">
      <el-form
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              label="Raktár"
            >
              <el-select
                v-model="storage"
                value-key="id"
                style="width: 100%;"
                filterable
              >
                <el-option
                  v-for="s in storages"
                  :key="s.id"
                  :label="s.name"
                  :value="s"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Időszak"
            >
              <el-date-picker
                v-model="dateRange"
                style="width: 100%;"
                type="daterange"
                :clearable="false"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="dateRangeOptions"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Esemény típusa"
            >
              <el-select
                v-model="selectedEventTypes"
                filterable
                multiple
                collapse-tags
                style="width: 100%;"
              >
                <el-option
                  v-for="eventType in eventTypes"
                  :key="eventType.value"
                  :value="eventType.value"
                  :label="eventType.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Termék"
            >
              <el-select
                v-model="product"
                filterable
                remote
                :remote-method="searchProduct"
                :loading="productLoading"
                placeholder="Gépelj a kereséshez..."
                style="width: 100%;"
                value-key="id"
              >
                <el-option
                  v-for="p in products"
                  :key="p.id"
                  :value="p"
                  :label="p.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: center;">
        <el-button
          :disabled="isDisabled"
          :loading="listLoading"
          icon="el-icon-tickets"
          @click="listProductHistory"
        >
          Listázás
        </el-button>
        <el-button
          :disabled="isDisabled"
          :loading="downloadLoading"
          icon="el-icon-download"
          @click="excelExport"
        >
          Letöltés
        </el-button>
        <el-button
          :disabled="isDisabled"
          :loading="printLoading"
          icon="el-icon-printer"
          @click="print"
        >
          Nyomtatás
        </el-button>
      </div>
    </div>
    <product-history-list style="margin-top: 30px"/>
  </el-card>
</template>

<script>
import ProductHistoryList from '../../components/reports/productHistory/List';
import moment from 'moment';

export default {
  components: {
    ProductHistoryList,
  },
  data() {
    return {
      loading: false,
      downloadLoading: false,
      printLoading: false,
      filterConfig: null,
      storage: null,
      dateRange: [moment().startOf('year').toDate(), moment().toDate()],
      productLoading: false,
      product: null,
      products: [],
      selectedEventTypes: ['customerSale', 'customerOrder', 'inwardHandling', 'representativeSale', 'representativePlacement', 'customerReturnOrder', 'declutter', 'stockTakingDifference', 'representativeTransfer', 'representativeReceive', 'representativeDrop', 'representativeDelivery', 'supplierReturnOrder', 'packing'],
      eventTypes: [
        { label: 'Bevételezés', value: 'inwardHandling' },
        { label: 'Beszállítói visszáru', value: 'supplierReturnOrder' },
        { label: 'Központi eladás', value: 'customerSale' },
        { label: 'Központi rendelés', value: 'customerOrder' },
        // { label: 'Raktárközi rendelés', value: 'representativeOrder' },
        { label: 'Képviselői bevételezés (Rak. köz. szállítólevél)', value: 'representativeDelivery' },
        { label: 'Képviselői leadás', value: 'representativeDrop' },
        { label: 'Képviselői eladás', value: 'representativeSale' },
        { label: 'Képviselői kihelyezés', value: 'representativePlacement' },
        { label: 'Vevői visszáru', value: 'customerReturnOrder' },
        { label: 'Selejtezés', value: 'declutter' },
        { label: 'Csomagolás', value: 'packing' },
        { label: 'Leltáreltérés', value: 'stockTakingDifference' },
        { label: 'Képviselői átadás (-)', value: 'representativeTransfer' },
        { label: 'Képviselői átadás (+)', value: 'representativeReceive' },
      ],
      dateRangeOptions: {
        firstDayOfWeek: 1,
        shortcuts: [{
          text: 'Aktuális hét',
          onClick(picker) {
            const start = moment().weekday(1).toDate();
            const end = moment().weekday(7).toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző hét',
          onClick(picker) {
            const start = moment().subtract({ weeks: 1 }).weekday(1).toDate();
            const end = moment().subtract({ weeks: 1 }).weekday(7).toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Aktuális hónap',
          onClick(picker) {
            const start = moment().startOf('month').toDate();
            const end = moment().endOf('month').toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző hónap',
          onClick(picker) {
            const start = moment().subtract({ months: 1 }).startOf('month').toDate();
            const end = moment().subtract({ months: 1 }).endOf('month').toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző 3 hónap',
          onClick(picker) {
            const start = moment().subtract({ months: 3 }).startOf('month').toDate();
            const end = moment().subtract({ months: 1 }).endOf('month').toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Aktuális év',
          onClick(picker) {
            const start = moment().startOf('year').toDate();
            const end = moment().endOf('year').toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző év',
          onClick(picker) {
            const start = moment().subtract({ years: 1 }).startOf('year').toDate();
            const end = moment().subtract({ years: 1 }).endOf('year').toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'YTD',
          onClick(picker) {
            const start = moment().startOf('year').toDate();
            const end = moment().toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'MTD',
          onClick(picker) {
            const start = moment().startOf('month').toDate();
            const end = moment().toDate();
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    };
  },
  computed: {
    storages() {
      return this.$store.getters['storage/storages'];
    },
    isDisabled() {
      return !this.product || !this.storage || !this.dateRange;
    },
    listLoading() {
      return this.$store.getters['productHistory/loading'];
    },
  },
  async mounted() {
    this.loading = true;
    await this.setConfig();
    this.loading = false;
  },
  methods: {
    async setConfig() {
      if (!this.storages.length) {
        await this.$store.dispatch('storage/fetchAll');
        this.storage = this.storages.find(s => s.type === 'own');
      }
    },
    async searchProduct(query) {
      if (query !== '') {
        this.productLoading = true;
        this.products = await this.$store.dispatch('product/search', '?name=' + query);
        this.productLoading = false;
      }
    },
    listProductHistory() {
      this.$store.dispatch('productHistory/fetchAll', `?storage_id=${this.storage.id}&from=${moment(this.dateRange[0]).startOf('day').format('YYYY-MM-DD HH:mm')}&to=${moment(this.dateRange[1]).endOf('day').format('YYYY-MM-DD HH:mm')}&product_id=${this.product.id}&types=${this.selectedEventTypes.join(',')}`);
    },
    async excelExport() {
      this.downloadLoading = true;
      const excel = await axios({
        url: 'api/reports/product-history/download',
        method: 'POST',
        responseType: 'blob',
        data: {
          product_id: this.product.id,
          storage_id: this.storage.id,
          'from': moment(this.dateRange[0]).startOf('day').format('YYYY-MM-DD HH:mm'),
          to: moment(this.dateRange[1]).endOf('day').format('YYYY-MM-DD HH:mm'),
          types: this.selectedEventTypes.join(','),
        },
      });
      this.downloadLoading = false;
      saveAs(excel, 'product_history.xlsx');
    },
    async print() {
      this.printLoading = true;
      const response = await axios.post('api/reports/product-history/print',  {
        product_id: this.product.id,
        storage_id: this.storage.id,
        'from': moment(this.dateRange[0]).startOf('day').format('YYYY-MM-DD HH:mm'),
        to: moment(this.dateRange[1]).endOf('day').format('YYYY-MM-DD HH:mm'),
        types: this.selectedEventTypes.join(','),
      }, {
        responseType: 'arraybuffer',
        headers: {
          'Accept': 'application/pdf'
        },
      });
      this.printLoading = false;

      const newBlob = new Blob([response], { type: 'application/pdf' });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      const data = window.URL.createObjectURL(newBlob);
      window.open(data);
    },
  }
};
</script>

<style lang="scss">
  .filter-container {
    padding: 20px;
    margin: -20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #EBEEF5;
  }
  .el-picker-panel [slot=sidebar], .el-picker-panel__sidebar {
    width: 150px;
  }
  .el-picker-panel [slot=sidebar]+.el-picker-panel__body, .el-picker-panel__sidebar+.el-picker-panel__body {
    margin-left: 150px;
  }
</style>
